import { render, staticRenderFns } from "./Candidates.vue?vue&type=template&id=5fdcadbf&scoped=true"
import script from "./Candidates.vue?vue&type=script&lang=js"
export * from "./Candidates.vue?vue&type=script&lang=js"
import style0 from "./Candidates.vue?vue&type=style&index=0&id=5fdcadbf&prod&lang=scss&scoped=true"
import style1 from "./Candidates.vue?vue&type=style&index=1&id=5fdcadbf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdcadbf",
  null
  
)

export default component.exports